import React, { useState, useEffect, useContext } from 'react'
import { CdnImage, CdnPath } from '../../shared/cdn-image'
import Loader from '../../shared/loader'
import { navigate, useLocation} from "@reach/router"
import QuoteContext from "../quote-context";
import axios from 'axios'

const SuperPackages = ({ locationId, selectedSuperPackage }) => {

    const location = useLocation();
    const {navigation, navigationDispatcher, formData, formDispatcher} = useContext(QuoteContext);
    const [ superPackages, setSuperPackages ] = useState( [] )
    const [ filteredSuperPackages, setFilteredSuperPackages ] = useState([])
    const [ loading, setLoading ] = useState( true )
    const [ selectedFilter, setSelectedFilter ] = useState(2)


    useEffect(() => {
		window.scrollTo({
			top: 137,
			behavior: 'smooth'
		})

        const postData = new FormData();
		postData.append( 'date', formData.date );
		postData.append( 'pax', formData.pax );

        axios.post( '/quote/v2/superpackages/' + locationId, postData ).then(response => {

            setLoading(false);
            setSuperPackages( response.data.superpackages );
            setSelectedFilter( response.data.defaultNights );
            setFilteredSuperPackages( response.data.superpackages.filter(sp => sp.nights == response.data.defaultNights ) )
        }).catch(err => {
            setLoading(false);
            const message = ( err.response.data != null && err.response.data.message != undefined ) ? err.response.data.message : err.message;
            navigationDispatcher({type: "RAISE_ERROR", message: message, code: null });
            navigationDispatcher({
                type: 'TRACK_EVENT',
                action: 'error',
                category: 'load-errors',
                name: 'load-superpackages',
                trigger: 'web-js',
                data:  {
                    message: message,
                    code: null
                }
            });
        });
	}, [])


    const setFilter = ( nights ) => {
        setSelectedFilter( nights )
        if( parseInt(nights) == 3 ) {
        	setFilteredSuperPackages( superPackages.filter(sp => sp.nights >= nights) )
        } else {
        	setFilteredSuperPackages( superPackages.filter(sp => sp.nights == nights) )
        }
    }
    return (
        <>
            { loading ? (

                <Loader />

            ) : (

                <>
                    <div className="full-width-block">
                        <div className="row">
                           
                            <div className="column">
                                { navigation.destination.hasSuperPackages && 
                                    <>
                                        <h3 className="mg-v-dsk-lrg mg-v-tch">Add Package with Accommodation</h3>
                                    </>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="full-width-block">
                        <div className="row no-padding">
                            <div className="column">
                                <div className="pd-h-tch pd-h-dsk-md">
                                    <div className="content-block shadow-dsk radius">
                                        <div className="pd-dsk-md">
                                            <div className="full-width-block">
                                                <div className="row no-padding-mob">
                                                    <div className="column">
                                                        <h4 className="primary">Freebies &amp; savings!</h4>
                                                        <p>When booking accommodation for this destination, you’re selecting a package that comprises of not only accommodation but also some complimentary extras like <strong>airport transfers and nightclub access</strong>. By choosing to book a package with us you’ll <strong>save money</strong> on both accommodation and all other aspects of your trip. After adding the package you’ll also have the option to <strong>add further activities</strong> via our easy to use quote form.</p>
                                                        <div className="align-content vertical center split-mob tabs mg-v-lrg">
                                                            <div className={selectedFilter == 0 ? `tab active` : `tab`} onClick={() => setFilter( 0 )}>Activity only</div>
                                                            <div className={selectedFilter == 1 ? `tab active` : `tab`} onClick={() => setFilter( 1 )}>1 Night</div>
                                                            <div className={selectedFilter == 2 ? `tab active` : `tab`} onClick={() => setFilter( 2 )}>2 Nights</div>
                                                            <div className={selectedFilter == 3 ? `tab active` : `tab`} onClick={() => setFilter( 3 )}>3+ Nights</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                                    
                                            <div className="full-width-block">
                                                <div className="row no-padding">
                                                    
                                                        { filteredSuperPackages.length == 0 && <div className="column">No packages were found.</div>}

                                                            <div className="align-content wrap">
                                                                {filteredSuperPackages.map( sp => {
                                                                    return (
                                                                        <div key={`sp-` + sp.id} className="grid-item one-quarter">
                                                                            <div className="grid-item__content mg-b-lrg">
                                                                                <a onClick={(event) => {
                                                                                navigationDispatcher({
                                                                                type: 'OPEN_MODAL',
                                                                                modal: './quote/modal/superpackage',
                                                                                title: sp.name,
                                                                                payload: {
                                                                                    siteId: navigation.siteId,
                                                                                    locationId: navigation.destination.id,
                                                                                    id: sp.id,
                                                                                    day: typeof location.state.day !== "undefined" ? parseInt(location.state.day) : 1,
                                                                                    selected: typeof selectedSuperPackage !== "undefined" && selectedSuperPackage.id == sp.id,
                                                                                    hasButton: true,
                                                                                    date: formData.date,
                                                                                    pax: formData.pax,
                                                                                    cheapest: sp.cheapest,
                                                                                    addSuperPackage: ( selectedSuperPackage ) => {
                                                                                        formDispatcher({type:"ADD_SUPER_PACKAGE", superPackage: selectedSuperPackage});
                                                                                        navigationDispatcher({ type: "GOTO_STEP", step: "itinerary", params: null});
                                                                                        navigationDispatcher({
                                                                                            type: 'TRACK_EVENT',
                                                                                            action: 'event',
                                                                                            category: 'click',
                                                                                            name: 'add-super-package',
                                                                                            trigger: 'web-js',
                                                                                            data: {
                                                                                                day: selectedSuperPackage.day,
                                                                                                id: selectedSuperPackage.id,
                                                                                                name: selectedSuperPackage.name,
                                                                                                nights: selectedSuperPackage.nights
                                                                                            }
                                                                                        });
                                                                                    }
                                                                                }
                                                                            })

                                                                            navigationDispatcher({
                                                                                type: 'TRACK_EVENT',
                                                                                action: 'event',
                                                                                category: 'click',
                                                                                name: 'view-superpackage',
                                                                                trigger: 'web-js',
                                                                                data: {
                                                                                    id: sp.id,
                                                                                    name: sp.name,
                                                                                }
                                                                            });

                                                                        }}>
                                                                            <>
                                                                                <div className={ selectedSuperPackage != false && selectedSuperPackage.id == sp.id ? `selected image radius full-width height-250 mg-b` : `image radius full-width height-250 mg-b`} style={{backgroundSize: 'cover', backgroundImage: `url("${CdnPath( navigation.siteId, sp.image )}")`}}>
                                                                                    <div>
                                                                                        {/* <div className="banner_holder">
                                                                                            <div className={`banner icon-nights-${sp.nights}`}></div>
                                                                                        </div> */}
                                                                                        { selectedSuperPackage != false && selectedSuperPackage.id == sp.id ? <div className="align-content vertical center top banner primary"><span className="icon icon-tick white left"></span> Added to package</div> : null }
                                                                                    </div>
                                                                                </div>
                                                                                
                                                                                <h4 className="item__content--title">{sp.name}</h4>
                                                                                <p className="text-medium bold">Includes:</p>
                                                                                <ul className="list disc indented">
                                                                                    <li>{sp.nights} nights in centrally located accomodation</li>
                                                                                    {sp.events.map( event => (
                                                                                        <li key={`sp-event-${event.id}`}>{event.name}</li>
                                                                                    ))}
                                                                                </ul>
                                                                            </>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                                )
                                                            })}
                                                        </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="full-width-block">
                                    <div className="row no-padding">
                                        <div className="column">
                                            <div className="pd-h-tch pd-h-dsk-md">
                                                <h3 className="mg-t-lrg">Looking for activities only?</h3>
                                                <p>If you don’t need accommodation, please go back and click 'Add activities' where you can add items to your quote. Then just hit submit to get a price.</p>
                                                <button className="button secondary radius mg-v-lrg" onClick={() => {navigate('./')}}><span className="icon icon-chevron-left white small left"></span> Back</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </>
                
            )}
        </>
	)
}

export default SuperPackages;
